export default "__VITE_ASSET__B_IGFI$o__ 148w, __VITE_ASSET__CkrS$3se__ 296w, __VITE_ASSET__Beu_zcd___ 444w";